import { Chip, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { kitStatusTagChoices } from './helpers/kitFieldsHelpers'

const StatusTagsInput = () => {
    const { watch, setValue } = useFormContext()
    const status = watch('status')
    const statusTags = watch('statusTags') || []

    const canEdit = ['manualReview', 'error'].includes(status)

    const handleAddTag = (event) => {
        const detail = event.target.value
        if (!detail) return
        const newTag = `${status}-${detail}`

        if (!statusTags.includes(newTag)) {
            setValue('statusTags', [...statusTags, newTag], { shouldDirty: true })
        }
    }

    const handleDeleteTag = (tagToDelete) => {
        setValue('statusTags', statusTags.filter(tag => tag !== tagToDelete), { shouldDirty: true })
    }

    return (
        <div style={{ margin: '1em 0' }}>
            <InputLabel shrink sx={{ marginBottom: '8px' }}>Status Tags</InputLabel>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '8px', minHeight: '32px', alignItems: 'center' }}>
                {statusTags.map((tag) => (
                    <Chip
                        key={tag}
                        label={tag}
                        onDelete={canEdit ? () => handleDeleteTag(tag) : undefined}
                        size="small"
                        sx={{ marginBottom: 1 }}
                    />
                ))}
                {statusTags.length === 0 && <span style={{ color: 'rgba(0, 0, 0, 0.6)', fontStyle: 'italic', fontSize: '0.9rem' }}>No tags</span>}
            </div>

            {canEdit && (
                <FormControl size="small" sx={{ minWidth: 200 }}>
                    <InputLabel>Add Status Detail</InputLabel>
                    <Select
                        label="Add Status Detail"
                        value=""
                        onChange={handleAddTag}
                    >
                        {kitStatusTagChoices.map(choice => (
                            <MenuItem key={choice.id} value={choice.id}>{choice.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </div>
    )
}

export default StatusTagsInput
